/**
 * Mocked article data for preview/mocked flows.
 * Used when in mocked mode to show a pre-populated article.
 */

import type { ArticleDetail } from '@/common/api/models.pleased';

/**
 * Create mocked article data with realistic content
 */
export const createMockedArticle = (): ArticleDetail => ({
  id: 123,
  title: 'How to Reset Your Password',
  enTitle: 'How to Reset Your Password',
  body: `
    <h2>Resetting Your Password</h2>
    <p>If you've forgotten your password or need to reset it for security reasons, follow these simple steps:</p>
    
    <h3>Step 1: Navigate to the Login Page</h3>
    <p>Go to the login page and click on the "Forgot Password?" link below the login form.</p>
    
    <h3>Step 2: Enter Your Email</h3>
    <p>Enter the email address associated with your account. Make sure it's the same email you used when you registered.</p>
    
    <h3>Step 3: Check Your Email</h3>
    <p>We'll send you an email with a password reset link. This link will be valid for 24 hours.</p>
    
    <h3>Step 4: Create a New Password</h3>
    <p>Click the link in the email and enter your new password. Your password should:</p>
    <ul>
      <li>Be at least 8 characters long</li>
      <li>Contain at least one uppercase letter</li>
      <li>Contain at least one number</li>
      <li>Contain at least one special character</li>
    </ul>
    
    <h3>Step 5: Log In</h3>
    <p>Once you've set your new password, you can log in with your email and new password.</p>
    
    <h2>Troubleshooting</h2>
    <p>If you don't receive the reset email within a few minutes:</p>
    <ul>
      <li>Check your spam or junk folder</li>
      <li>Make sure you entered the correct email address</li>
      <li>Try requesting another reset link</li>
    </ul>
    
    <p>If you continue to have issues, please contact our support team for assistance.</p>
  `,
  articleConfig: {
    id: 123,
    title: 'How to Reset Your Password',
    action: 'GO_ACCOUNT_SETTINGS',
    actionMessage: 'Was this article helpful?',
    actionText: 'Go to Account Settings',
  },
  category: {
    id: 2,
    brandId: 1,
    title: 'Account & Security',
    titleTranslated: 'Account & Security',
    description: 'Help with account management and security',
    descriptionTranslated: 'Help with account management and security',
    position: 2,
    isActive: true,
    language: 'en',
    englishVersion: true,
  },
});
